module.exports = "/img/20.fabe56.webp";